import OperatorCometListener from "~/operatorApplication/ts/service/comet/OperatorCometListener";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {OperatorApplicationRoutingStore} from "~/operatorApplication/ts/store/OperatorApplicationRoutingStore";
import {
    BEFORE_OPERATOR_LOGGED_OUT,
    MAKE_OPERATOR_LOGOUT,
    OPERATOR_LOGGED_OUT,
    OPERATOR_RELOAD_APP_CONFIG,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {OperatorApplicationSoundPlayer} from "~/operatorApplication/ts/service/OperatorApplicationSoundPlayer";

export default function operatorLogout(error?: string) {
    console.log(error);
    if (OperatorAccountStore.isAuthorized.value) {
        OperatorApplicationEventManager.emit(BEFORE_OPERATOR_LOGGED_OUT);
        setTimeout(() => {
            (new OperatorApiRequest({
                url: "/operator/logout",
                silent: true,
                silentError: true
            })).setCheckSessionUid(false).send();
            OperatorCometListener.stop();
            OperatorAccountStore.logOut(error);
            OperatorApplicationRoutingStore.clear();
            OperatorApplicationPlatform.window.setBadge(null);
            OperatorApplicationPlatform.notifications.closeAll();
            ClientUserdataStore.clear();
            OperatorApplicationSoundPlayer.stopAll();
            OperatorApplicationEventManager.emit(OPERATOR_RELOAD_APP_CONFIG, OperatorApplicationConfigInstance);
            OperatorApplicationEventManager.emit(OPERATOR_LOGGED_OUT);
        }, 10);

    }
    OperatorApplicationConfigInstance.useInternationalHostIfNeed();
}

OperatorApplicationEventManager.addEventListener(MAKE_OPERATOR_LOGOUT, e => {
    operatorLogout(e);
});

